const deglawyPortalContentPath = '/deglawy/portal';
export const getDeglawyPortalContentById = (id: number) => `${deglawyPortalContentPath}/content/${id}`;
export const updateDeglawyPortalContentById = (id: number) => `${deglawyPortalContentPath}/content/${id}`;
export const getDeglawyPortalContents = `${deglawyPortalContentPath}/content`;
